import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { timestampDate } from '@bufbuild/protobuf/wkt';
import { KpiListModel } from '~/pages/Dashboard/models/KpiListModel';
import { listKpis } from './api/kpi.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';
import { SimulationModel } from '~/shared/models/system/SimulationModel';
import { getSystemSimulationQuery } from '~/shared/api/simulations.queries';

export type DashboardPageLoaderResult = {
  simulation: SimulationModel;
  kpis: KpiListModel;
};

export const dashboardSimulationLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<Response | DashboardPageLoaderResult> => {
    await checkAuthorization(queryClient, request);

    const { simulationId } = params;

    assertIsDefined(simulationId);

    const simulation = await queryClient.ensureQueryData(
      getSystemSimulationQuery({ simulationId }),
    );

    const { system } = simulation;

    const kpisModel = await queryClient.ensureQueryData(
      listKpis({
        systemName: system.name,
        dateRange: [
          timestampDate(simulation.timeFrom),
          timestampDate(simulation.timeTo),
        ],
        simulation,
        kpiMetricTypes: system.availableKpis,
      }),
    );

    return {
      simulation,
      kpis: kpisModel,
    };
  };
